const ITEMS = [
  "PRODUCT MANAGEMENT THINKING",
  "STRATEGY",
  "OPERATING SYSTEMS",
  "PRACTICAL AI",
  "CONTINUOUS IMPROVEMENT",
  "DESIGN LIKE A PRODUCT",
  "RUN LIKE A SYSTEM",
  "SCALE WITH AI",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-line bg-parch py-4"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-10 whitespace-nowrap font-mono text-xs uppercase tracking-[0.3em] text-ink/60"
          >
            {item}
            <span className="text-amber">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
